import { axios } from "../../utils";

export async function deleteSubuser({ formData, accessToken }) {
  const response = await axios.delete(`/subuser/${formData.email}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response;
}
